import * as actionTypes from '../actions/actionTypes';
import { FETCH_CONTENT_SCHEMA_SUCCEEDED, UPDATE_TITLE_FROM_INLINE, UPDATE_POST_BODY, ADDED_MODULES_TO_POST_BODY, CONTENT_SAVE_REQUEST_SUCCEEDED, FETCH_CONTENT_SUCCEEDED } from 'ContentEditorUI/redux/actions/actionTypes';
import { Map as ImmutableMap, fromJS } from 'immutable';
import withBaseContentModel, { withBaseContentModelAsJSObject } from 'ContentEditorUI/redux/reducers/contentModel/withBaseContentModel';
import featuredImageReducer, { featuredImageReducerAsJSObject } from 'ContentEditorUI/redux/reducers/contentModel/featuredImageReducer';
import basePublishReducer, { basePublishReducerAsJSObject } from 'ContentEditorUI/redux/reducers/contentModel/publish/basePublishReducer';
import produce from 'immer';
const areTagIdsandListsEqualAsJSObject = (immutableIds = [], newIds = [], immutableIdList = [], currentList = []) => {
  return immutableIds.join(',') === newIds.join(',') && immutableIdList.length === currentList.length;
};
const areTagIdsandListsEqual = (
// @ts-expect-error ts-migrate(7009) FIXME: 'new' expression, whose target lacks a construct s... Remove this comment to see the full error message
immutableIds = new ImmutableList(), newIds = [],
// @ts-expect-error ts-migrate(7009) FIXME: 'new' expression, whose target lacks a construct s... Remove this comment to see the full error message
immutableIdList = new ImmutableList(), currentList = []) => {
  return immutableIds.toJS().join(',') === newIds.join(',') && immutableIdList.size === currentList.length;
};
const initialState = {
  blogAuthor: null,
  blogAuthorId: null,
  contentGroupId: 0,
  enableGoogleAmpOutputOverride: false,
  isCrawlableByBots: false,
  label: '',
  page_title: '',
  postBody: '',
  publicAccessRules: [],
  publicAccessRulesEnabled: false,
  resolvedDomain: '',
  slug: '',
  state: 'DRAFT',
  tagIds: [],
  tagList: [],
  templatePath: '',
  textToAudioFileId: null,
  title: '',
  translatedFromId: null,
  headHtml: '',
  scheduledUpdateDate: null
};
export const postContentModelReducerAsJSObject = withBaseContentModelAsJSObject(basePublishReducerAsJSObject, featuredImageReducerAsJSObject, (state = initialState, {
  type,
  payload,
  response
}) => produce(state, draft => {
  switch (type) {
    case FETCH_CONTENT_SCHEMA_SUCCEEDED:
      {
        const {
          content,
          content_group
        } = response;
        return Object.assign(draft, {
          blogAuthor: content.blogAuthor,
          blogAuthorId: content.blogAuthorId,
          contentGroupId: content.contentGroupId,
          enableGoogleAmpOutputOverride: content.enableGoogleAmpOutputOverride,
          isCrawlableByBots: content.isCrawlableByBots,
          label: content.label,
          page_title: content.pageTitle,
          postBody: content.postBody,
          parentBlog: content.parentBlog,
          publicAccessRules: content.publicAccessRules,
          publicAccessRulesEnabled: content.publicAccessRulesEnabled,
          resolvedDomain: content.resolvedDomain,
          slug: content.slug,
          state: content.state,
          tagIds: content.tagIds,
          tagList: content.tagList,
          templatePath: content_group.itemTemplatePath,
          textToAudioFileId: content.textToAudioFileId,
          title: content.title,
          translatedFromId: content.translatedFromId,
          translatedContent: content.translatedContent,
          headHtml: content.headHtml,
          scheduledUpdateDate: content.scheduledUpdateDate
        });
      }
    case FETCH_CONTENT_SUCCEEDED:
      draft.scheduledUpdateDate = payload.scheduledUpdateDate;
      return draft;
    case actionTypes.UPDATE_POST_CONTENT_MODEL_HEAD_HTML:
      draft.headHtml = payload;
      return draft;
    case actionTypes.UPDATE_POST_CONTENT_MODEL_BLOG_AUTHOR_ID:
      draft.blogAuthorId = payload;
      return draft;
    case actionTypes.UPDATE_POST_CONTENT_MODEL_BLOG_AUTHOR:
      draft.blogAuthor = payload;
      return draft;
    case UPDATE_TITLE_FROM_INLINE:
      {
        const {
          title
        } = payload;
        if (draft.htmlTitle === draft.name) {
          draft.htmlTitle = title;
        }
        draft.title = title;
        draft.name = title;
        return draft;
      }
    case actionTypes.UPDATE_POST_CONTENT_MODEL_TITLE:
      {
        const {
          title,
          customizeTitleEnabled
        } = payload;
        if (!customizeTitleEnabled && draft.htmlTitle === draft.name) {
          draft.htmlTitle = title;
        }
        draft.title = title;
        draft.name = title;
        return draft;
      }
    case actionTypes.UPDATE_POST_CONTENT_MODEL_CONTENT_GROUP_ID:
      draft.contentGroupId = payload;
      return draft;
    case actionTypes.UPDATE_POST_CONTENT_MODEL_TAG_IDS:
      draft.tagIds = payload;
      return draft;
    case actionTypes.CREATE_POST_AUTHOR_SUCCEEDED:
      {
        const {
          blogAuthor
        } = payload;
        const blogAuthorId = blogAuthor.id;
        return Object.assign(draft, {
          blogAuthor,
          blogAuthorId
        });
      }
    case actionTypes.CREATE_POST_TAG_SUCCEEDED:
    case actionTypes.CREATE_POST_TAG_TRANSLATION_SUCCEEDED:
      {
        const payloadId = parseInt(payload.id, 10);
        if (isNaN(payloadId)) {
          return draft;
        }
        if (draft.tagIds) draft.tagIds.push(payloadId);
        return draft;
      }
    case ADDED_MODULES_TO_POST_BODY:
    case UPDATE_POST_BODY:
      {
        const {
          html
        } = payload;
        if (draft.postBody === html) return draft;
        draft.postBody = html;
        return draft;
      }
    case actionTypes.UPDATE_ENABLE_GOOGLE_AMP_OUTPUT_OVERRIDE:
      draft.enableGoogleAmpOutputOverride = payload;
      return draft;
    case actionTypes.UPDATE_POST_CONTENT_MODEL_SLUG:
      draft.slug = payload.contentModelSlug;
      return draft;
    case actionTypes.UPDATE_POST_CONTENT_MODEL_LANGUAGE:
      {
        const {
          blogSlug,
          contentGroupId,
          language,
          slugRaw
        } = payload;
        // blog slug from new contentGroupId accounts for language slug in it
        const slug = blogSlug ? `${blogSlug}/${slugRaw}` : slugRaw;

        // Update `language` in content model redux to reflect change in translation
        // picker and validation, but no need to save it via API since it gets synced by blog
        return Object.assign(draft, {
          contentGroupId,
          slug,
          language
        });
      }
    case CONTENT_SAVE_REQUEST_SUCCEEDED:
      {
        const {
          response: {
            responseJSON: {
              tag_ids,
              tag_list
            }
          }
        } = payload;
        const currentTagIds = draft.tagIds;
        const currentTagList = draft.tagList;
        if (areTagIdsandListsEqualAsJSObject(currentTagIds, tag_ids, currentTagList, tag_list)) {
          return draft;
        }
        return Object.assign(draft, {
          tagIds: tag_ids,
          tagList: tag_list
        });
      }
    case actionTypes.UPDATE_POST_CONTENT_MODEL_TEMPLATE:
      {
        draft.templatePath = payload;
        return draft;
      }
    case actionTypes.UPDATE_POST_CONTENT_MODEL_PUBLIC_ACCESS_RULES:
      {
        draft.publicAccessRules = payload;
        return draft;
      }
    case actionTypes.UPDATE_POST_CONTENT_MODEL_PUBLIC_ACCESS_RULES_ENABLED:
      {
        draft.publicAccessRulesEnabled = payload;
        return draft;
      }
    case actionTypes.UPDATE_POST_CONTENT_MODEL_SEO_CRAWLING_ENABLED:
      {
        draft.isCrawlableByBots = payload;
        return draft;
      }
    case actionTypes.UPDATE_TEXT_TO_AUDIO_FILE_ID:
      {
        draft.textToAudioFileId = payload.fileId;
        return draft;
      }
    default:
      return draft;
  }
}));
const postSettingsReducer = (state = ImmutableMap(initialState), {
  type,
  payload,
  response
}) => {
  switch (type) {
    case FETCH_CONTENT_SCHEMA_SUCCEEDED:
      {
        const {
          content,
          content_group
        } = response;
        // Set this separately so that state.merge doesn't recursively turn
        // publicAccessRules into an Immutable List
        state = state.set('publicAccessRules', content.publicAccessRules);
        return state.merge({
          blogAuthor: content.blogAuthor,
          blogAuthorId: content.blogAuthorId,
          contentGroupId: content.contentGroupId,
          enableGoogleAmpOutputOverride: content.enableGoogleAmpOutputOverride,
          isCrawlableByBots: content.isCrawlableByBots,
          label: content.label,
          page_title: content.pageTitle,
          postBody: content.postBody,
          parentBlog: content.parentBlog,
          publicAccessRulesEnabled: content.publicAccessRulesEnabled,
          resolvedDomain: content.resolvedDomain,
          slug: content.slug,
          state: content.state,
          tagIds: content.tagIds,
          tagList: content.tagList,
          templatePath: content_group.itemTemplatePath,
          textToAudioFileId: content.textToAudioFileId,
          title: content.title,
          translatedFromId: content.translatedFromId,
          translatedContent: content.translatedContent,
          headHtml: content.headHtml,
          scheduledUpdateDate: content.scheduledUpdateDate
        });
      }
    case FETCH_CONTENT_SUCCEEDED:
      return state.set('scheduledUpdateDate', payload.scheduledUpdateDate);
    case actionTypes.UPDATE_POST_CONTENT_MODEL_HEAD_HTML:
      return state.set('headHtml', payload);
    case actionTypes.UPDATE_POST_CONTENT_MODEL_BLOG_AUTHOR_ID:
      return state.set('blogAuthorId', payload);
    case actionTypes.UPDATE_POST_CONTENT_MODEL_BLOG_AUTHOR:
      return state.set('blogAuthor', fromJS(payload));
    case UPDATE_TITLE_FROM_INLINE:
      {
        const {
          title
        } = payload;
        let newState = state.merge({
          title,
          name: title
        });
        if (state.get('htmlTitle') === state.get('name')) {
          newState = newState.merge({
            htmlTitle: title
          });
        }
        return newState;
      }
    case actionTypes.UPDATE_POST_CONTENT_MODEL_TITLE:
      {
        const {
          title,
          customizeTitleEnabled
        } = payload;
        let newState = state.merge({
          title,
          name: title
        });
        if (!customizeTitleEnabled && state.get('htmlTitle') === state.get('name')) {
          newState = newState.merge({
            htmlTitle: title
          });
        }
        return newState;
      }
    case actionTypes.UPDATE_POST_CONTENT_MODEL_CONTENT_GROUP_ID:
      return state.set('contentGroupId', payload);
    case actionTypes.UPDATE_POST_CONTENT_MODEL_TAG_IDS:
      return state.set('tagIds', fromJS(payload));
    case actionTypes.CREATE_POST_AUTHOR_SUCCEEDED:
      {
        const {
          blogAuthor
        } = payload;
        const blogAuthorId = blogAuthor.id;
        return state.merge({
          blogAuthor,
          blogAuthorId
        });
      }
    case actionTypes.CREATE_POST_TAG_SUCCEEDED:
    case actionTypes.CREATE_POST_TAG_TRANSLATION_SUCCEEDED:
      {
        const payloadId = parseInt(payload.id, 10);
        if (isNaN(payloadId)) {
          return state;
        }
        return state.set('tagIds', state.get('tagIds').push(payloadId));
      }
    case ADDED_MODULES_TO_POST_BODY:
    case UPDATE_POST_BODY:
      {
        const {
          html
        } = payload;
        if (state.get('postBody') === html) return state;
        return state.set('postBody', html);
      }
    case actionTypes.UPDATE_ENABLE_GOOGLE_AMP_OUTPUT_OVERRIDE:
      return state.set('enableGoogleAmpOutputOverride', payload);
    case actionTypes.UPDATE_POST_CONTENT_MODEL_SLUG:
      return state.set('slug', payload.contentModelSlug);
    case actionTypes.UPDATE_POST_CONTENT_MODEL_LANGUAGE:
      {
        const {
          blogSlug,
          contentGroupId,
          language,
          slugRaw
        } = payload;
        // blog slug from new contentGroupId accounts for language slug in it
        const slug = blogSlug ? `${blogSlug}/${slugRaw}` : slugRaw;

        // Update `language` in content model redux to reflect change in translation
        // picker and validation, but no need to save it via API since it gets synced by blog
        return state.merge({
          contentGroupId,
          slug,
          language
        });
      }
    case CONTENT_SAVE_REQUEST_SUCCEEDED:
      {
        const {
          response: {
            responseJSON: {
              tag_ids,
              tag_list
            }
          }
        } = payload;
        const currentTagIds = state.get('tagIds');
        const currentTagList = state.get('tagList');
        if (areTagIdsandListsEqual(currentTagIds, tag_ids, currentTagList, tag_list)) {
          return state;
        }
        return state.merge({
          tagIds: tag_ids,
          tagList: tag_list
        });
      }
    case actionTypes.UPDATE_POST_CONTENT_MODEL_TEMPLATE:
      {
        return state.set('templatePath', payload);
      }
    case actionTypes.UPDATE_POST_CONTENT_MODEL_PUBLIC_ACCESS_RULES:
      {
        return state.set('publicAccessRules', payload);
      }
    case actionTypes.UPDATE_POST_CONTENT_MODEL_PUBLIC_ACCESS_RULES_ENABLED:
      {
        return state.set('publicAccessRulesEnabled', payload);
      }
    case actionTypes.UPDATE_POST_CONTENT_MODEL_SEO_CRAWLING_ENABLED:
      {
        return state.set('isCrawlableByBots', payload);
      }
    case actionTypes.UPDATE_TEXT_TO_AUDIO_FILE_ID:
      {
        return state.set('textToAudioFileId', payload.fileId);
      }
    default:
      return state;
  }
};
export default withBaseContentModel(basePublishReducer, featuredImageReducer, postSettingsReducer);